import { ThemeColorsModel } from "./theme.model";
import { Theme } from "@material-ui/core";
import { hexToRgbA } from "common-react";

export const typedKeys = <T extends object>(obj: T) =>
  Object.keys(obj) as Array<keyof T>;

export const isColorLeaf = (value: unknown): value is string =>
  typeof value === "string";

export const getColorPaths = (
  colors: ThemeColorsModel,
  prefix = ""
): string[] => {
  return Object.keys(colors).flatMap((key) => {
    const value = colors[key as keyof ThemeColorsModel];
    const path = prefix ? `${prefix}.${key}` : key;
    if (typeof value === "string") {
      return [path];
    }
    return getColorPaths(value as ThemeColorsModel, path);
  });
};

export const themeColorsRgba = ({ color }: Theme) => ({
  black8: hexToRgbA(color.greys[80], 0.08),
  black16: hexToRgbA(color.greys[80], 0.16),
  black40: hexToRgbA(color.greys[80], 0.40),
  white8: hexToRgbA(color.greys[0], 0.08),
  white16: hexToRgbA(color.greys[0], 0.16),
  primary12: hexToRgbA(color.oranges[50], 0.12),
  primary40: hexToRgbA(color.oranges[50], 0.40),
});

export const blendRGBA = (base: string, overlay: string): string => {
  const parse = (s: string) => s.match(/\d+(\.\d+)?/g)?.map(Number) || [];
  const [r1, g1, b1, a1] = parse(base);
  const [r2, g2, b2, a2] = parse(overlay);

  const a = a2 + a1 * (1 - a2);
  const r = Math.round((r2 * a2 + r1 * a1 * (1 - a2)) / a);
  const g = Math.round((g2 * a2 + g1 * a1 * (1 - a2)) / a);
  const b = Math.round((b2 * a2 + b1 * a1 * (1 - a2)) / a);

  return `rgba(${r},${g},${b},${a})`;
}